import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";

import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  Legend,
} from "recharts";

const COLORS = ["#0d6efd", "#198754", "#ffc107", "#dc3545", "#8800CC"];

const Overview = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get("/reports/overview").then((res) => {
      setData(res.data);
    });
  }, []);

  if (!data) return <p className="text-center my-5">Loading...</p>;

  return (
    <div className="container my-4">
      <h2 className="mb-4">Overview Dashboard</h2>

      {/* Summary Cards */}
      <div className="row g-3 mb-4">
        <div className="col-md-3 col-6">
          <div className="card text-center shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Total Sales</h5>
              <p className="display-6 fw-bold text-success">
                ${data.totalSales}
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div className="card text-center shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Orders</h5>
              <p className="display-6 fw-bold">{data.totalOrders}</p>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div className="card text-center shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Customers</h5>
              <p className="display-6 fw-bold">{data.totalCustomers}</p>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div className="card text-center shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Low Stock</h5>
              <p className="display-6 fw-bold text-danger">
                {data.lowStockCount}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Orders Growth + Sales by Payment */}
      <div className="row g-4">
        {/* Orders Growth */}
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h6 className="mb-3">Orders Growth</h6>
              <div style={{ width: "100%", height: 250 }}>
                <ResponsiveContainer>
                  <LineChart data={data.ordersGrowth}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <Line
                      type="monotone"
                      dataKey="count"
                      stroke="#0d6efd"
                      strokeWidth={3}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>

        {/* Sales by Category */}
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h6 className="mb-3">Sales by Category</h6>
              <div style={{ width: "100%", height: 250 }}>
                <ResponsiveContainer>
                  <PieChart>
                    <Pie
                      data={data.categoryData}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      outerRadius={80}
                      label
                    >
                      {data.categoryData.map((_, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Top 5 Products */}
      <div className="row g-4 mt-4">
        <div className="col-md-12">
          <div className="card shadow-sm">
            <div className="card-body">
              <h6 className="mb-3">🔥 Top 5 Products</h6>
              <div style={{ width: "100%", height: 300 }}>
                <ResponsiveContainer>
                  <BarChart data={data.topProducts}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="title" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="salesCount" fill="#0d6efd" />
                    <Bar dataKey="totalRevenue" fill="#198754" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
